@import '../styles/fonts.scss';
@import '../styles/palette.scss';
@import '../styles/deviceBreakpoints.scss';

.flex {
  display: flex;
}

.generalInfo {
  @include barlow(20);
  border-bottom: 1px solid;
  padding: 1em 0;

  @include target(mobile) {
    @include barlow(14);
  }

  .checkboxes {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    @include target(mobile) {
      flex-direction: column;
      margin-top: 0.5rem;
    }
  }

  .numChosen {
    background-color: _palette(secondary);
    border: 1px solid;
    border-radius: 20px;
    color: white;
    display: inline-block;
    font-weight: 600;
    padding: 0.25rem 1rem;
  }

  .choosePraksissteder {
    @include barlow(30, 600);

    @include target(mobile) {
      @include barlow(16);
    }

    display: flex;
    gap: 0.5rem;
    align-items: center;

    button {
      width: 2.5rem;
      display: flex;
      height: 2.5rem;
      justify-content: center;
      align-items: center;

      &:hover,
      &:focus {
        outline: black auto 0.25rem;
        outline-offset: -0.25rem;
      }
    }

    .helpIcon {
      background-color: inherit;
      border: none;
      color: _palette(secondary);
      scale: 1.25;

      &:hover,
      &:focus {
        color: _palette(secondary-dark);
      }
    }
  }

  .datePeriod {
    @include barlow(18);
    text-align: right;

    @include target(mobile) {
      @include barlow(14);
      margin-top: 0.625rem;
      text-align: left;

      .dates {
        @include barlow(16);
      }
    }

    .dates {
      @include barlow(20);
      color: _palette(secondary);
      font-weight: 600;
    }
  }
}

.praksisstederWrapper {
  margin-top: 2.5rem;

  .headings {
    h4 {
      @include barlowMedium(16);
    }

    h5 {
      @include barlowMedium(14);
    }

    h5:last-child {
      display: flex;
      color: _palette(primary);

      &::before {
        display: inline-block;
        margin-right: 0.33rem;
        transform: scaleX(-1);
        content: '↵';
      }
    }
  }

  .praksisstedWrapper {
    margin-bottom: 2.5rem;
  }

  .praksissted {
    display: flex;
    flex-direction: column;
    background-color: _palette(card);
    border-radius: 12px;
    box-shadow: 0.5rem 0.5rem 1rem #ccc;
    height: calc(100% + 2.82rem);
    max-width: 31rem;
    min-height: 37rem;
    position: relative;

    //Smaller cards on mobiles
    @include target(mobile) {
      min-height: 22rem;

      .picture svg {
        height: 8.125rem;
      }

      .replacementPicture {
        height: 8.125rem;
        padding-left: calc(50% - 2.5rem);
        padding-top: 1.6rem;

        .iconWrapper {
          height: auto;
          width: auto;
        }

        svg {
          background-color: white;
          height: 2.2rem;
          margin: 1.5rem;
          width: 2.2rem;
        }
      }
    }

    .picture img {
      border-top-left-radius: 0.75rem;
      border-top-right-radius: 0.75rem;
      height: 16.25rem;
      object-fit: cover;
      width: 100%;
    }

    .replacementPicture {
      flex: 0 1 auto;
      background-color: _palette(profile-picture-bg);
      border-top-left-radius: 0.75rem;
      border-top-right-radius: 0.75rem;
      height: 16.25rem;
      padding-left: calc(50% - 3.75rem);
      padding-top: 4.7rem;
      position: relative;

      .iconWrapper {
        background-color: white;
        border-radius: 50%;
        height: 7.5rem;
        position: absolute;
        width: 7.5rem;
      }

      svg {
        background-color: white;
        height: 4.375rem;
        margin: 1.5rem;
        width: 4.375rem;
      }
    }

    .text {
      flex: 0 1 auto;
      @include barlow(17);
      padding: 0.75rem;

      @include target(mobile) {
        @include barlow(14);

        .avdelingsnavn {
          @include barlow(16);
        }
      }

      a {
        color: _palette(secondary);
      }

      .avdelingsnavn {
        @include barlow(20);
        font-weight: 600;
      }

      .beskrivelse {
        margin-top: 0.625rem;
        word-wrap: break-word;

        h5 {
          @include barlowMedium(14);
        }
      }

      .readMoreLink {
        font-weight: 600;
      }
    }

    .choiceAndPriority {
      flex: 1 1 auto;
      display: flex;
      justify-content: end;
      align-items: center;
      width: 100%;
      flex-direction: column;
      padding-bottom: 1.5rem;
      gap: 0.5rem;

      .priorityWrapper {
        @include barlowMedium(16);
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .choiceBtn {
        min-width: fit-content;
        width: 9.5rem; // Default button width

        &.unchooseButton {
          background-color: white;
          color: black;
        }
      }
    }
  }
}

.dialog {
  @include barlow(18);
  width: 55%;
  min-width: 15rem;

  .dialogHeader {
    flex-direction: column;

    h2 {
      @include barlow(24, 600);
      color: _palette(secondary);
    }

    img {
      margin: 0 auto 0.8rem;
      max-height: 45vh;

      @include target(mobile) {
        max-height: 25vh;
      }
    }
  }

  p {
    margin: auto;
    max-width: 60%;

    @include target(md) {
      max-width: 75%;
    }

    & + p {
      margin-top: 1rem;
    }
  }

  @include target(tablet) {
    width: 100%;

    p {
      max-width: 100%;
    }
  }

  .content {
    padding: 1.25rem;
  }

  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
